import { TICK_HZ } from '@chessshooter/shared';

// Knobs of the online mode: how the client hides latency. Nothing here changes the simulation; the
// server decides every outcome (rule 5). Simulation tuning stays in shared/src/constants.ts.

/** port the dev server listens on by default (server/src/config.ts), used when VITE_WS_URL is unset */
export const DEV_SERVER_PORT = 8080;
/** path the production reverse proxy forwards to the game server (docs/DEPLOY.md, step 9) */
export const PROD_WS_PATH = '/ws';

/** how far behind the newest snapshot the opponent and the world are shown; jitter up to this stays invisible */
export const INTERP_DELAY_MS = 120;
export const INTERP_DELAY_TICKS = (INTERP_DELAY_MS / 1000) * TICK_HZ;
/** the render clock runs this much faster or slower while it is off its target (never backwards) ... */
export const CLOCK_CATCH_UP = 0.1;
/**
 * ... once it is off by more than this many ticks. Half a snapshot interval (3 ticks, server config), so
 * the saw-tooth the arrival of each snapshot causes fits inside and the clock runs at exactly real time ...
 */
export const CLOCK_DEAD_BAND_TICKS = 1.5;
/** ... and jumps when off by more than this (a stall, a tab switch): better one cut than seconds of fast forward */
export const CLOCK_SNAP_TICKS = 0.5 * TICK_HZ;
/** snapshots older than this behind the render clock are forgotten */
export const SNAPSHOT_KEEP_TICKS = 2 * TICK_HZ;

/** a misprediction is faded out at this fraction per 60 Hz frame (frame-rate corrected) ... */
export const CORRECTION_DECAY_RATE = 0.25;
/** ... unless the own figure is off by more than this, world units: then it snaps */
export const CORRECTION_SNAP_DISTANCE = 64;
/** a residual smaller than this is dropped so the figure comes to rest exactly where predicted */
export const CORRECTION_EPSILON = 0.05;

/** unconfirmed inputs kept for replay; a longer stall loses the oldest (the server would too) */
export const MAX_PENDING_INPUTS = 2 * TICK_HZ;

/** ms between pings; the HUD shows the round trip */
export const PING_INTERVAL_MS = 2000;
/** no snapshot for this long during a match shows a connection warning */
export const STALL_WARNING_MS = 1500;
/** reconnect delays after a lost socket; the last one repeats */
export const RECONNECT_DELAYS_MS: readonly number[] = [500, 1000, 2000, 4000, 8000];
